<template>
  <div class="educational-picker-wrapper onboarding-block-wrapper">
    <div class="onboarding-block-container">
      <div class="onboarding-block-title">请选择你的学历背景：</div>
      <div class="desc-title">最高学历<span>*</span></div>
      <div class="flex items-center" style="gap: 12px; margin-bottom: 20px">
        <el-select
          :value="form.degree"
          class="onboarding-picker-select flex-1"
          popper-class="onboarding-select-popper"
          placeholder="请选择"
          @change="degreeChange"
        >
          <el-option
            v-for="(item, index) in degreeList"
            :key="index"
            :label="item.cn"
            :value="item.id"
          />
        </el-select>
        <el-select
          :value="form.edu_type"
          class="onboarding-picker-select flex-1"
          popper-class="onboarding-select-popper"
          placeholder="请选择"
          @change="eduTypeChange"
        >
          <el-option
            v-for="(item, index) in eduTypes"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="desc-title">学校名称<span>*</span></div>
      <EditorAutoComplete
        :value="form.university"
        class="onboarding-university"
        placeholder="请输入学校名称"
        popper-class="onboarding-select-popper"
        value-key="name"
        :remoteMethodCallback="fetchUniversityRemoteMethod"
        @clickPickerItem="universityChange($event, form)"
      />
      <div class="desc-title" style="margin-top: 20px">{{ identity === 'student' ? '预计毕业时间' : '毕业时间' }}<span>*</span></div>
      <el-date-picker
        v-model="form.graduate_at"
        :value="form.graduate_at"
        :clearable="false"
        class="onboarding-picker-select"
        popper-class="onboarding-select-popper"
        type="month"
        placeholder="请选择"
        value-format="yyyy-MM"
        @change="endDateChange"
      ></el-date-picker>
      <div class="desc-title" style="margin-top: 16px">专业<span>*</span></div>
      <EditorAutoComplete
        :value="form.major"
        placeholder="请输入专业名称"
        class="onboarding-university"
        popper-class="onboarding-select-popper"
        :remoteMethodCallback="fetchMajorRemoteMethod"
        @clickPickerItem="majorChange($event, form)"
      />
    </div>
  </div>
</template>
<script>
import api from '@/api';
import EditorAutoComplete from '@/views/editor2025/components/EditorAutoComplete/EditorAutoComplete.vue';
import EditorDatePicker from '@/views/editor2025/components/EditorDatePicker/EditorDatePicker.vue';
import degree from '@/assets/json/degree';
import { EDU_TYPES } from '../const';
export default {
  name: 'EducationalPicker',
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    identity: String,
  },
  components: {
    EditorAutoComplete,
    EditorDatePicker,
  },
  data() {
    return {
      degreeList: degree,
      eduTypes: EDU_TYPES.cn,
    };
  },
  methods: {
    degreeChange(value) {
      const item = this.degreeList.find((item) => item.id === value);
      const degreeInfo = {
        degree: item.cn || null,
        degree_id: value || null,
      };

      if (!degreeInfo.degree) {
        degreeInfo.edu_type = null;
      } else if (!this.form.edu_type) {
        degreeInfo.edu_type = '全日制';
      }

      this.$emit('educationChange', { ...this.form, ...degreeInfo });
    },
    eduTypeChange(value) {
      this.$emit('educationChange', { ...this.form, edu_type: value });
    },
    universityChange(data) {
      const university = typeof data === 'string' ? data : data.name;
      const university_id = typeof data === 'string' ? null : data.id;
      this.$emit('educationChange', { ...this.form, university, university_id });
    },
    majorChange(data) {
      const major = typeof data === 'string' ? data : data.name;
      const major_id = typeof data === 'string' ? null : data.id;
      this.$emit('educationChange', { ...this.form, major, major_id });
    },
    endDateChange(value) {
      this.$emit('educationChange', { ...this.form, graduate_at: value });
    },
    async fetchUniversityRemoteMethod(query) {
      try {
        if (!query) return [];
        return await api.cvsEditor.universityAutoCompletions({
          keyword: query,
        });
      } catch (error) {
        console.log(error);
      }
    },
    async fetchMajorRemoteMethod(query) {
      try {
        if (!query) return [];
        return await api.cvsEditor.majorAutoCompletions({
          keyword: query,
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../styles/component.scss';
.educational-picker-wrapper {
  .onboarding-block-container {
    width: 622px;
    margin-left: 64px;
    .onboarding-block-title {
      font-size: 16px;
      line-height: 16px;
      color: #fff;
      margin-bottom: 20px;
    }
    .desc-title {
      color: #9a9ca2;
      font-size: 12px;
      line-height: 12px;
      margin-bottom: 12px;
      span {
        color: #ff6644;
        margin-left: 4px;
        line-height: 12px;
      }
    }
    .onboarding-picker-select {
      height: 40px;
      overflow: hidden;
      &:has(input:focus) {
        @extend .focus;
      }
      ::v-deep(.el-input__inner),
      ::v-deep(.el-input__suffix),
      ::v-deep(.el-input__prefix) {
        z-index: 10;
      }
      ::v-deep(.el-input__inner) {
        position: relative;
      }
    }
    .onboarding-university {
      ::v-deep(.el-autocomplete) {
        width: 100%;
        height: 40px;
        overflow: hidden;
        .el-input {
          &:has(input:focus) {
            @extend .focus;
          }
          .el-input__inner {
            @extend .input__inner;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
@import '../styles/index.scss';
</style>
